import { useAppConfiguration, useGraphqlQuery } from '@mews-commander/data-access';
import { graphql, GuestSummaryByIdResultQueryVariables } from '@mews-commander/guest-profile';

const GuestSummaryAnalyticsQueryDocument = graphql(`
    query guestSummaryAnalyticsResult($guestId: UUID!, $currency: String!) {
        guestSummaryById(guestId: $guestId) {
            analytics {
                lastStayDate
                totalAmountSpent(currency: $currency) {
                    currencyCode
                    grossAmount
                    netAmount
                }
                totalNightsSpent
                totalStays
            }
        }
    }
`);

export const useAnalytics = ({ guestId, currency }: GuestSummaryByIdResultQueryVariables & { currency: string }) => {
    const { guestProfileApiUrl } = useAppConfiguration();
    return useGraphqlQuery(
        guestProfileApiUrl,
        {
            document: GuestSummaryAnalyticsQueryDocument,
            variables: { guestId, currency },
        },
        {
            enabled: !!guestId && !!currency,
        }
    );
};
